<template>
  <div>
    <div class="ibox" v-if="order">
      <div class="ibox-title">Order details</div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-9 col-lg-9">
              <form action="" id="postRestrictions">
                <div class="search-form col-lg-12">
                  <div class="input-group col-lg-12">
                    <div class="ibox-content">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="typePost">Type:</label></div>
                            <div class="col-lg-8">
                              <div class="col-lg-4">
                                <input type="checkbox" name="type[post]" id="typePost"> Posts
                              </div>
                              <div class="col-lg-4">
                                <input type="checkbox" name="type[page]" id="typePage"> Pages
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="iLang">Language:</label></div>
                            <div class="col-lg-8">
                              <select name="language" id="iLang" class="col-lg-8" ref="language">
                                <option value="">---</option>
                                <option :value="key" v-for="(lang, key) in langs" v-bind:key="key">{{ lang }}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="iTitle">Title:</label></div>
                            <div class="col-lg-8">
                              <input type="text" name="title" id="iTitle" class="col-lg-12">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row m-t-md">
                        <div class="search col-lg-12">
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="iRDFrom">RD:</label></div>
                            <div class="col-lg-8">
                              <input type="number" min="0" name="RDFrom" id="iRDFrom" placeholder="from" class="col-lg-6" ref="rdFrom" @keydown.enter="searchPosts">
                              <input type="number" min="0" name="RDTo" id="iRDTo" placeholder="to" class="col-lg-6" ref="rdTo" @keydown.enter="searchPosts">
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="iTFFrom">TF:</label></div>
                            <div class="col-lg-8">
                              <input type="number" min="0" name="TFFrom" id="iTFFrom" placeholder="from" class="col-lg-6" ref="tfFrom" @keydown.enter="searchPosts">
                              <input type="number" min="0" name="TFTo" id="iTFTo" placeholder="to" class="col-lg-6" ref="tfTo" @keydown.enter="searchPosts">
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="iDAFrom">DA:</label></div>
                            <div class="col-lg-8">
                              <input type="number" min="0" name="DAFrom" id="iDAFrom" placeholder="from" class="col-lg-6" ref="daFrom" @keydown.enter="searchPosts">
                              <input type="number" min="0" name="DATo" id="iDATo" placeholder="to" class="col-lg-6" ref="daTo" @keydown.enter="searchPosts">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row m-t-md">
                        <div class="search col-lg-12">
                          <div class="col-lg-4">
                            <div class="col-lg-4"><label for="iRDFrom">Categories:</label></div>
                            <div class="col-lg-8">
                              <v-select multiple="multiple" v-model="selectedCategories" :options="categories" name="categories"></v-select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="row">
                <auto-orders :auto-replace-orders="this.autoReplaceOrders"></auto-orders>
              </div>
              <div class="input-group">
                <input type="text" class="form-control" ref="searchPosts" @keydown.enter="searchPosts">
                <span class="input-group-append"><button type="button" class="btn btn-primary" @click="searchPosts">Search!</button></span>
              </div>
              <div class="row" v-if="searchResults.length">
                <table class="table small table-striped table-bordered table-hover m-b-xs m-t-md">
                  <thead>
                  <tr>
                    <th>Title</th>
                    <th>Lang</th>
                    <th>Added</th>
                    <th>Modified</th>
                    <th>Category</th>
                    <th>RD</th>
                    <th>TF</th>
                    <th>DA</th>
                    <th>Site</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="post in searchResults" v-bind:key="post.id" @click="loadPost(post.site.id, post.postId)">
                    <td>
                      <span class="label" v-bind:class="getClassType(post.type)">{{ post.type }}</span>
                      {{ post.title }}
                    </td>
                    <td>{{ post.lang }}</td>
                    <td>{{ $moment(post.postDate.date).format('DD.MM.YYYY') }}</td>
                    <td>{{ $moment(post.modified.date).calendar() }}</td>
                    <td>{{ post.site.stats.ttf0 }}</td>
                    <td>{{ post.site.stats.rd }}</td>
                    <td>{{ post.site.stats.tf }}</td>
                    <td>{{ post.site.stats.da }}</td>
                    <td>{{ post.site.url }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-3">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Id</td>
                  <td><strong>{{ order.id }}</strong></td>
                </tr>
                <tr>
                  <td>Link</td>
                  <td>
                    <strong>{{ order.link }}</strong>
                  </td>
                <tr>
                  <td>Anchor</td>
                  <td><strong>{{ order.anchor }}</strong></td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td>{{ $moment(order.date.date).format('DD.MM.YYYY') }}</td>
                </tr>
                <tr>
                  <td>Count</td>
                  <td>{{ order.count }}</td>
                </tr>
                <tr>
                  <td>Placed</td>
                  <td><strong>{{ 0 }}</strong></td>
                </tr>
                <tr>
                  <td>Remaining</td>
                  <td>{{ order.count }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PostSearch',
  props: ['langs', 'order'],
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Client/PostSearch.vue